// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221905/js/" + chunkId + "." + {"44":"e1885efe","225":"ec1402ee","481":"1c73bfd3","486":"46a640ea","770":"33b2ea5d"}[chunkId] + ".0.42690625701117.chunk.js";
};